import { HyperLink } from '../../../Common/Form'

const BackToListingQueryLink = props => {
  return (
    <>
      返回
      <HyperLink href='/listing/query'>
        賣場查詢
      </HyperLink>
    </>
  )
}

export default BackToListingQueryLink
